<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const { t } = useI18n();
</script>

<template>
  <MpText no-margin>
    {{ t('JOB_APPLICATION_SUCCESS_PAGE.SAVE_SEARCH_SUCCESS_TOAST.SUBTITLE_1') }}
    <LinksLocale :to="{ name: 'my-notifications' }">
      <MpText link>
        {{ t('JOB_APPLICATION_SUCCESS_PAGE.SAVE_SEARCH_SUCCESS_TOAST.SUBTITLE_2') }}
      </MpText>
    </LinksLocale>
  </MpText>
</template>
